// Angular
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
// 3rd-party
import { Observable } from 'rxjs';

@Injectable()
export class BuyerGuardService  {
    constructor(private router: Router) {}

    canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (window.localStorage.getItem('companyTypeCode') === 'buyer') {
            return true;
        } else if (window.localStorage.getItem('companyTypeCode') === 'sample-authority') {
            return this.router.parseUrl('/');
        }

        return false;
    }
}
